import { useEffect, useState } from 'react'

type Countdown = { hours: number; minutes: number; seconds: number }
const DAY = 24 * 60 * 60 * 1000
const STORAGE_KEY = 'porcion_rentable_countdown_end'

function getTimeLeft(endTime: number): Countdown {
  const difference = Math.max(0, endTime - Date.now())
  return {
    hours: Math.floor((difference % DAY) / (60 * 60 * 1000)),
    minutes: Math.floor((difference % (60 * 60 * 1000)) / (60 * 1000)),
    seconds: Math.floor((difference % (60 * 1000)) / 1000),
  }
}

function getEndTime() {
  const saved = Number(localStorage.getItem(STORAGE_KEY))
  if (Number.isFinite(saved) && saved > Date.now()) return saved

  const endTime = Date.now() + DAY
  localStorage.setItem(STORAGE_KEY, String(endTime))
  return endTime
}

export function useCountdown() {
  const [timeLeft, setTimeLeft] = useState<Countdown>({ hours: 23, minutes: 59, seconds: 59 })

  useEffect(() => {
    const endTime = getEndTime()
    const update = () => setTimeLeft(getTimeLeft(endTime))
    update()
    const interval = window.setInterval(update, 1000)
    return () => window.clearInterval(interval)
  }, [])

  return timeLeft
}
